import React, { useState, useEffect } from "react";

import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import axios from "../../../../../utils/axiosInceptor";
import { ReactSelectField, InputField } from "../../../../atoms/FormElement";
import { CheckCircleFilled, CloseCircleOutlined, EditOutlined } from "@ant-design/icons";
import { Row, Col, Button, Form, Typography, message, Card, Input } from "antd";
import { portalService } from "../../../../../configs/constants";
const { Title } = Typography;
import _ from 'lodash';
import { useDispatch } from "react-redux";
import { assignShiftData } from "../../ducks/actions";

const AddOperatingHours = (props) => {
  const [noEdit, setNoEdit] = useState(true);
  const [shiftsDropDown, setShiftsDropDown] = useState([]);
  const shiftsApi = useSelector((state: any) => state.calendar.shiftData);
  const dispatch: any = useDispatch();

  const days = [
    { title: 'Sunday', key: 0 },
    { title: 'Monday', key: 1 },
    { title: 'Tuesday', key: 2 },
    { title: 'Wednesday', key: 3 },
    { title: 'Thursday', key: 4 },
    { title: 'Friday', key: 5 },
    { title: 'Saturday', key: 6 },
  ];

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();


  useEffect(() => {
    reset();
    shiftsApi?.shifts?.length > 0 ? setShiftsDropDown(shiftsApi?.shifts?.map(e => ({ label: e?.name, value: e?._id })))
      : setShiftsDropDown([]);
  }, [shiftsApi])

  const onFinish = async (values) => {
    if (!(values?.shiftSelections?.length > 0) || !props?.providerData) { message.error("Failed to update"); return; }
    const days = _.map(values.shiftSelections, (shift, day) => ({
      day: parseInt(day, 10),
      ...(shift.value !== null && { shift: shift.value })
    }));

    const postJson = {
      schedules: days,
      provider: props?.providerData,
      ...(values?.userCount && { userCount: parseInt(values?.userCount) })
    };

    try {
      const url = `${portalService}/roaster/assign-shift`;
      await axios.put(url, postJson);
      // props?.onSubmit();
      message.success("Operating days updated successfully");
      setNoEdit(true);
      dispatch(assignShiftData({
        ...shiftsApi,
        config: {
          ...shiftsApi.config,
          schedules: postJson.schedules,
          userCount: postJson.userCount ?? shiftsApi.config.userCount, 
          provider: postJson.provider ?? shiftsApi.config.provider 
        }
      }));
    } catch (e) {
      setNoEdit(true);
      message.error(e?.response?.data?.message);
    }
  };

  const getAssignedShift = (index: number) => {
    const slot = shiftsApi?.config?.schedules?.length > 0 && shiftsApi?.config?.schedules?.find(e => e.day === index);
    const shiftObj = (slot?.shift && shiftsApi?.shifts?.length > 0) ? shiftsApi?.shifts?.find(e => e._id === slot.shift) : null;
    return shiftObj ? { label: shiftObj?.name, value: shiftObj?._id } : null;
  };

  useEffect(() => {
    shiftsApi?.config?.userCount ? setValue("userCount", shiftsApi?.config?.userCount) : setValue("userCount", "");
  }, [shiftsApi]);

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card
            bordered={false}
            // bodyStyle={{ padding: "0 32px 42px" }}
            headStyle={{ padding: "0 32px", borderBottom: 0 }}
            className="operating-hours"
            title={
              <Title level={3} className="mb-0">
                {noEdit ? "" : "Edit"} Operating Hours
              </Title>
            }
            extra={[
              <Button
                key={1}
                type="link"
                className={`p-0 no-border no-shadow ${noEdit && "d-none"}`}
                icon={<CloseCircleOutlined />}
                onClick={() => setNoEdit(true)}
                htmlType="button">
                &nbsp; Cancel
              </Button>,
              <Button
                key={2}
                type="link"
                className={`p-0 no-border no-shadow ${noEdit && "d-none"}`}
                icon={<CheckCircleFilled />}
                htmlType="submit"
              >
                &nbsp;  Save
              </Button>,
              <Button
                key={3}
                type="link"
                className={`p-0 no-border no-shadow ${!noEdit && "d-none"}`}
                icon={<EditOutlined />}
                onClick={() => setNoEdit(false)}
                disabled={props?.isDisabled}
                htmlType="button"
              >
                &nbsp; Edit
              </Button>,
            ]}
          >


            <Row gutter={24} className="days-list">
              <Col span={21}>
                <Title level={5} className="ag-primary">
                  Days
                </Title>

              </Col>
            </Row>
            <Row gutter={30} className="days-list">

              {days.map((item, index) => (
                <Col key={index} flex={"auto"} style={{ maxWidth: '195px' }}>
                  {item.title}
                  <ReactSelectField
                    fieldname={`shiftSelections[${item.key}]`}
                    control={control}
                    selectOption={[{ label: "Select Shift", value: null }, ...shiftsDropDown]}
                    placeholder="Select Shift"
                    valueGot={getAssignedShift(index)}
                    setValue={setValue}
                    // onChange={(value) => handleShiftChange(item.key, value)}
                    iProps={{ isDisabled: noEdit }}
                    initValue={null} // shiftSelections[item.key] || null}
                  />
                </Col>
              ))}

            </Row>

            <Row>
              <Col>
                {shiftsApi?.config?.userCount ? (<>
                  <div style={{ paddingBottom: "8px" }}>Agents</div>
                  <Input
                    aria-label="Agents"
                    value={shiftsApi?.config?.userCount ?? ""}
                    disabled={true}
                  />
                </>) :
                  (<InputField
                    label="Agents"
                    fieldname="userCount"
                    iProps={{ placeholder: "Enter agents" }}
                    initValue=""
                    // valueGot={shiftsApi?.config?.userCount}
                    // setValue={setValue}
                    disabled={noEdit}
                    isRequired={true}
                    control={control}
                    rules={{ required: "Agents Required" }}
                    validate={errors.userCount && "error"}
                    validMessage={errors.userCount && errors.userCount.message}
                  />)
                }

              </Col>
            </Row>


          </Card>
        </Col>
      </Row>
    </Form >
  );
};

export default AddOperatingHours;